import { render, staticRenderFns } from "./AuthorizationForm.vue?vue&type=template&id=7d11065a&scoped=true"
import script from "./AuthorizationForm.vue?vue&type=script&lang=js"
export * from "./AuthorizationForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationForm.vue?vue&type=style&index=0&id=7d11065a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d11065a",
  null
  
)

export default component.exports